import { render, staticRenderFns } from "./EpPromotionTargetCardList.vue?vue&type=template&id=e0161e86&"
import script from "./EpPromotionTargetCardList.vue?vue&type=script&lang=js&"
export * from "./EpPromotionTargetCardList.vue?vue&type=script&lang=js&"
import style0 from "./EpPromotionTargetCardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports